var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 5.41667C13.1583 5.41667 15.975 7.19167 17.35 10C15.975 12.8083 13.1666 14.5833 9.99998 14.5833C6.83331 14.5833 4.02498 12.8083 2.64998 10C4.02498 7.19167 6.84165 5.41667 9.99998 5.41667ZM9.99998 3.75C5.83331 3.75 2.27498 6.34167 0.833313 10C2.27498 13.6583 5.83331 16.25 9.99998 16.25C14.1666 16.25 17.725 13.6583 19.1666 10C17.725 6.34167 14.1666 3.75 9.99998 3.75ZM9.99998 7.91667C11.15 7.91667 12.0833 8.85 12.0833 10C12.0833 11.15 11.15 12.0833 9.99998 12.0833C8.84998 12.0833 7.91665 11.15 7.91665 10C7.91665 8.85 8.84998 7.91667 9.99998 7.91667ZM9.99998 6.25C7.93331 6.25 6.24998 7.93333 6.24998 10C6.24998 12.0667 7.93331 13.75 9.99998 13.75C12.0666 13.75 13.75 12.0667 13.75 10C13.75 7.93333 12.0666 6.25 9.99998 6.25Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.08cfccb8f81cc6c4d15920f3d16a5c3d.svg";
export { ForwardRef as ReactComponent };